/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockedDaysOfYearDto } from '../../models/blocked-days-of-year-dto';

export interface BlockedDays$Params {
}

export function blockedDays(http: HttpClient, rootUrl: string, params?: BlockedDays$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockedDaysOfYearDto>>> {
  const rb = new RequestBuilder(rootUrl, blockedDays.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BlockedDaysOfYearDto>>;
    })
  );
}

blockedDays.PATH = '/blocked-days';
